<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">

        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download"> Excel İndir
        </el-button>
        <a v-if="Ozet" @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <el-row :gutter="24">
        <div class="raporbloksabitle">
          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Site / Bina" prop="Bina_id">
                <el-select v-model="Form.Bina_id" filterable clearable>
                  <el-option-group
                    label="Site Listesi">
                    <el-option
                      v-for="item in Siteler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                  <el-option-group
                    label="Bina Listesi">
                    <el-option
                      v-for="item in Binalar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="Kategori" prop="Kategori_id">
                <el-cascader
                  collapse-tags
                  :props="{ multiple: true}"
                  :options="Kategoriler"
                  v-model="Form.Kategori_id"
                  filterable clearable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Bilgi" class="Tooltip" prop="Bilgi">
                <el-tooltip class="item" effect="dark"
                            content="Raporda ekstra gösterilmesini istediğiniz bilgileri seçiniz"
                            placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-select
                  v-model="Form.Bilgi"
                  collapse-tags
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Seçiniz">
                  <el-option
                    v-for="item in Bilgi"
                    :key="item.value"
                    :label="item.baslik"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item class="Tooltip" label="Özet" prop="Ozet">
                <el-tooltip class="item" effect="dark" content="Sadece borç bilgisini getirir."
                            placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-switch v-model="Form.Ozet"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>

        </div>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">

          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <div class="yazdirtable"> <!-- yazdirtable -->
            <h1>{{ Sayfa.Adi }}</h1>
            <table class="table table-bordered ">
              <thead>
              <tr>
                <th>Mesken</th>
                <th v-if="tableBilgi.Bina">Site/Bina</th>
                <th v-if="tableBilgi.Sahip">Mülk</th>
                <th v-if="tableBilgi.Kisi">Ad Soyad</th>
                <th v-if="tableBilgi.Telefon">Telefon</th>
                <th class="text-right">Devir</th>
                <th v-if="Ozet"
                    v-for="(value,index) in tableKategoriler" class="text-right">{{ value }}
                </th>
                <th class="text-right">Toplam Borç</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="t in tableData">
                <td>{{ t.Bilgi }}</td>
                <td v-if="tableBilgi.Bina">{{ t.Bina }}</td>
                <td v-if="tableBilgi.Sahip">{{ t.Sahip }}</td>
                <td v-if="tableBilgi.Kisi">{{ t.Kisi }}</td>
                <td v-if="tableBilgi.Telefon">{{ t.Telefon }}</td>
                <td class="text-right">{{ t.Devir }}</td>
                <td v-for="(value,index) in tableKategoriler" class="text-right">{{ t.BorcBilgi[index].Borc }}</td>
                <td class="text-right">{{ t.ToplamBorc }}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th :colspan="TableBilgiSay" class="text-right">ALT TOPLAM</th>
                <th class="text-right" v-for="(value,index) in AltToplam" v-if="AltToplam[index]">{{ AltToplam[index] }}
                </th>
              </tr>
              </tfoot>
            </table>
          </div>

          <el-table
            v-if="tableDisplay"
            class="table-xs yazdirma"
            :data="tableData"
            style="width: 100%"
            width="100%"
            border
            show-summary
            :height="Height"
            :summary-method="TableFooter"
          >
            <el-table-column
              label="Mesken"
              prop="Bilgi"
              fixed
            >
            </el-table-column>
            <el-table-column
              v-if="tableBilgi.Bina"
              label="Site/Bina"
              prop="Bina"
              width="200">
            </el-table-column>
            <el-table-column
              v-if="tableBilgi.Sahip"
              label="Mülk"
              prop="Sahip"
              width="100">
            </el-table-column>
            <el-table-column
              v-if="tableBilgi.Kisi"
              label="Ad Soyad"
              prop="Kisi"
              width="200">
            </el-table-column>
            <el-table-column
              v-if="tableBilgi.Telefon"
              label="Telefon"
              prop="Telefon"
              width="200">
            </el-table-column>
            <el-table-column
              label="Devir"
              prop="Devir"
              width="120"
              align="right"
            >
            </el-table-column>
            <el-table-column
              v-if="!Ozet"
              v-for="(value,index) in tableKategoriler"
              :label="value" align="center">
              <el-table-column
                label="Tahakkuk"
                width="120"
                align="right">
                <template slot-scope="scope">{{ scope.row.BorcBilgi[index].Tahakkuk }}</template>
              </el-table-column>
              <el-table-column
                label="Zam"
                width="120"
                align="right">
                <template slot-scope="scope">{{ scope.row.BorcBilgi[index].Zam }}</template>
              </el-table-column>
              <el-table-column
                label="Ödenen"
                width="120"
                align="right">
                <template slot-scope="scope">{{ scope.row.BorcBilgi[index].Odenen }}</template>
              </el-table-column>
              <el-table-column
                label="Borç"
                width="120"
                align="right">
                <template slot-scope="scope">{{ scope.row.BorcBilgi[index].Borc }}</template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              v-if="Ozet"
              v-for="(value,index) in tableKategoriler"
              :label="value"
              width="120"
              align="right">
              <template slot-scope="scope">{{ scope.row.BorcBilgi[index].Borc }}</template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="Toplam Borç"
              prop="ToplamBorc"
              width="120"
              align="right">
            </el-table-column>
          </el-table>
        </el-col>

      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));

import Yukleniyor from "../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      Height: 0,
      FiltreCollapse: '1',
      lo: false,
      Yetki: false,
      Kaydet: false,
      Ozet: true,
      Sayfa: {
        Adi: 'Alacak Listesi',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Bina_id: null,
        Tarih: [],
        Kategori_id: null,
        Bilgi: ['Kisi', 'Telefon'],
        Ozet: true
      },
      FormHata: {
        Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bilgi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      Bilgi: [
        {baslik: 'Bina Adı', value: 'Bina'},
        {baslik: 'Kişi Ad Soyad', value: 'Kisi'},
        {baslik: 'Sahip/Kiracı', value: 'Sahip'},
        {baslik: 'Telefon', value: 'Telefon'},
      ],
      RaporAdi: "",
      tableBilgi: [],
      KategoriKisiler: null,
      tableKategoriler: null,
      Kategoriler: [],
      Binalar: [],
      Siteler: [],
      tableData: [],
      ExcelData: [],
      tableDisplay: false,
      AltToplam: null,
      TableBilgiSay: 2
    }
  },
  methods: {

    Excel(evt) {
      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 15},
        {wch: 15},
        {wch: 15},
        {wch: 15},
        {wch: 15},
        {wch: 15},
        {wch: 15},
        {wch: 15},
        {wch: 15},
        {wch: 15},
      ];
      wb.Props = {
        Title: this.Sayfa.Adi,
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Sayfa.Adi,
      };
      XLSX.utils.book_append_sheet(wb, ws, this.Sayfa.Adi);
      XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");
    },
    Yazdir() {
      this.$prompt('Yazdırılacak sayfanın adını değişebilirsiniz.', 'Sayfa Adı', {
        confirmButtonText: 'Yazıcıya Gönder',
        cancelButtonText: 'Vazgeç',
        inputValue: this.Sayfa.Adi,
        inputPlaceholder: 'Yazdırma Sayfası'
      }).then(({value}) => {
        this.Sayfa.Adi = value;
        this.YaziciyaGonder(value);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Yazdırma İptal Edildi'
        });
      });
    },
    YaziciyaGonder() {
      setTimeout(() => {
        window.print();
      }, 100);
    },
    TableFooter() {
      return this.AltToplam;
    },
    Getir() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'raporlama/alacak/'})
            .then(response => {

              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.tableData;
                this.AltToplam = response.AltToplam;
                this.tableBilgi = response.tableBilgi;
                this.tableKategoriler = response.tableKategoriler;
                this.ExcelData = response.ExcelData;
                this.Ozet = response.Ozet;
                this.TableBilgiSay = response.TableBilgiSay;
                //this.RaporAdi = response.RaporAdi;
                if (this.tableData) this.tableDisplay = true;
                this.Height = window.innerHeight - 220
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })

    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kategoriler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'muhasebe/list/site'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
  },
  created() {
    this.SayfaYukle();
    this.Yetki = this.$store.getters.Yetki.raporlama == 2 ? true : false;
    var Gun = new Date();
    this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    if (this.$store.getters.BinaBilgi) {
      this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/alacak.vue